/* The hero figure's drawing pair: revision C to revision D.

   Generated data -- shape boxes read off the overlay SVGs -- and rewriting it
   by hand is how a frame stops sitting on its shape.

   `shapes` are the objects on the sheet -- connected geometry unioned into one
   box, measured per revision -- in sheet order, which is the order the
   animation frames and numbers them. `a`/`b` are the box as each revision
   draws it, in sheet coordinates. `state` and `changes` are what the compare
   found; `matched` means the object is the same in both, even where its view
   moved.

   The file used to hold a second pair (revisions A and B) and the A/B switch
   between them. Both went with the interactive figure; they are in git history
   before the commit that added RevisionAnimation.jsx. */

const figure = {
  a: "/figures/revision-c.svg",
  b: "/figures/revision-d.svg",
  aChanges: "/figures/revision-c-changes.svg",
  bChanges: "/figures/revision-d-changes.svg",
  aLetter: "C",
  bLetter: "D",
  width: 1684,
  height: 1191,
  shapes: [
    { id: "g1", state: "matched", changes: 0, a: [434, 48, 155, 146], b: [401, 48, 155, 146] },
    { id: "g2", state: "changed", changes: 1, a: [70, 56, 89, 190], b: [149, 126, 89, 189] },
    { id: "g4", state: "matched", changes: 0, a: [422, 270, 277, 167], b: [389, 294, 277, 167] },
    { id: "g5", state: "changed", changes: 5, a: [836, 472, 313, 483], b: [836, 468, 313, 483] },
    { id: "g6", state: "changed", changes: 2, a: [50, 484, 330, 452], b: [50, 484, 330, 449] },
    { id: "g7", state: "changed", changes: 8, a: [1363, 518, 148, 371], b: [1363, 515, 148, 371] },
    { id: "g8", state: "changed", changes: 1, a: [548, 550, 124, 386], b: [548, 553, 124, 380] }
  ],
};

export { figure };
